import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
class RouletteLeft extends Component {
	constructor(props) {
		super(props);
		this.state = {
			setTabId: 0
		}
	}
	//Mobile Tab
	loadLeftRightContMob = (cont_type) => {
		window.loadLeftRightMob(cont_type);
	}
	static getDerivedStateFromProps(props, state) {
		return {
			latestRouletteResult: props.latestRouletteResult
		};
	}
	NewselectDraw = (x, inx) => {
		this.props.selectDraw(x)
		this.setState({ setTabId: inx })
	}
	render() {
		const { t } = this.props;
		return (
			<div className='draesRslt'>
				{/* <div class="drawTabs">
					<div class="lottoBtomHeader">
						<div class="wrap3">
							<div id="drawTabs1" class="w50" onClick={() => { this.loadLeftRightContMob(1) }}>
								<h2>Draws</h2>
							</div>
							<div id="drawTabs2" class="w50" onClick={() => { this.loadLeftRightContMob(2) }}>
								<h2>Results</h2>
							</div>
						</div>
					</div>					
				</div> */}
				<div class="drawsRsltHead">
					<div>Draws & Results</div>
					<span>View upcoming draws and latest winning numbers</span>
				</div>

				<div class="draesRsltWrap">
					{/* {this.props.currentAvailableDraws && this.props.currentAvailableDraws.length > 0 &&
						<div class="nxtDraw">
							<div class="nxtDrawCont" onClick={() => { this.props.selectDraw(this.props.currentAvailableDraws[0]) }}>
								<div class="heading">
									<h4>Next Draw</h4>
								</div>
								<span class="nxtDrawRht">{this.props.reCount}</span>
								<span class="nxtDrawCent">{this.props.currentAvailableDraws[0].DrawDateTime}</span>
							</div>
						</div>} */}

					<div class="draesRsltCont scrollbar">
						<div class="lottoBtomHeader">
							<div class="wrap3">
								<div class="">
									<h2>Draws</h2>
								</div>
							</div>
						</div>
						<ul class="">
							{this.props.currentAvailableDraws && this.props.currentAvailableDraws.length > 1 ? this.props.currentAvailableDraws.filter((item, index) => index >= 1).map((x, indx) =>
								<li key={`lstav_${indx}`} onClick={() => { this.NewselectDraw(x, indx) }} className={(this.props.currentDraw != undefined && x.DrawID == this.props.currentDraw.DrawID) ? "Active" : ""}>
									<div class={this.state.setTabId == indx ? "lottodrwaNoRslt borderTxt activeDraw" : "lottodrwaNoRslt borderTxt"}><span class="">#{x.DrawNo}</span></div>
									<div class="lottoDateRslt"><span>{x.DrawDateTime}</span></div>
								</li>
							) :
								<li><div class="lottoDateRslt"><span>{t('lblNoMoreDraws')}</span></div></li>
							}

						</ul>
					</div>
					<div class="draesRsltCont scrollbar">
						<div class="lottoBtomHeader">
							<div class="wrap3">
								<div class="">
									<h2>Winning Numbers</h2>
								</div>
							</div>
						</div>
						<ul class="rltRslt">
							{this.props.latestRouletteResult && this.props.latestRouletteResult.length > 0 ? this.props.latestRouletteResult.map((x, indx) =>
								<li key={`lstrsl_${indx}`}>
									<div class="lottodrwaNoRslt borderTxt bg1">#{x.draw_no}</div>
									<span class="lottoDateRslt">{x.draw_date}{x.draw_time}</span>
									<div class="lottoBallRsltCont">
										<span class="lottoBallRslt borderTxt bg1">{x.winning_no}</span>
									</div>
								</li>) :
								<li>
									<div class="lottoDateRslt"><span>{t('lblnorecordfound')}</span></div>
								</li>
							}
						</ul>
						<div class="darwBtn">
							<span class="borderTxt"><Link to="/result">All Results</Link></span>
						</div>
					</div>
				</div>
			</div>
		);
	}
}


function mapStateToProps(state) {
	const { user } = state.loginReducer;
	const { currentDraw, cartItems, latestRouletteResult } = state.gameReducer;
	return { user, currentDraw, cartItems, latestRouletteResult };
}

const mapActionToProps = {
	//SetCurrentDraw:lottoActions.SetCurrentDraw,
}

export default connect(mapStateToProps, mapActionToProps)(withTranslation()(RouletteLeft))